import { useMutation, useQuery } from '@tanstack/react-query';
import * as api from '@/api/translateBatch';
import type { StartTranslateBatchInput } from '@/types/translateJob';

export function useProviders() {
  return useQuery({
    queryKey: ['translate-providers'],
    queryFn: api.listProviders,
    staleTime: 60_000,
  });
}

export function useStartTranslate() {
  return useMutation({
    mutationFn: (input: StartTranslateBatchInput) => api.startBatch(input),
  });
}

export function useJobPoll(jobId: string | null) {
  return useQuery({
    queryKey: ['translate-job', jobId],
    queryFn: () => api.getJob(jobId!),
    enabled: !!jobId,
    // Poll every 2s (not 1s) and pause while the tab is hidden — long batches
    // otherwise generate a lot of status requests.
    refetchIntervalInBackground: false,
    refetchInterval: (q) => {
      const job = q.state.data;
      if (!job) return 2000;
      // Terminal states — stop polling. 'partial' is terminal too (backend sets
      // it via the same final bump as 'success'), else the job polls forever.
      if (job.status === 'success' || job.status === 'partial' || job.status === 'failed') return false;
      return 2000;
    },
  });
}
